module.exports = __webpack_public_path__ + "static/img/112.cd84482.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/112.png
// module id = edth
// module chunks = 0